import React from 'react'
import CalendarMonthOutlined from '@mui/icons-material/CalendarMonthOutlined'
import ResourceCard from './ResourceCard'
import ResourceGroup from './ResourceGroup'
import { timelineLabel } from './constants'

export default function PathView({ sections, timelineUnit, onLaunch, onOpenHomework, onOpenEvaluation }) {
  const unit = timelineLabel[timelineUnit] || '阶段'
  return (
    <div className="path-view">
      {sections.map((section) => (
        <ResourceGroup
          key={section.no}
          title={section.title || (section.no ? `第${section.no}${unit}` : '未分组')}
          icon={<CalendarMonthOutlined className="group-icon" />}
          count={section.items.length}
        >
          {section.items.map((item) => (
            <ResourceCard
              key={item.key}
              item={item}
              onLaunch={onLaunch}
              onOpenHomework={onOpenHomework}
              onOpenEvaluation={onOpenEvaluation}
            />
          ))}
        </ResourceGroup>
      ))}
    </div>
  )
}
